import React from 'react'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import { Toaster } from 'sonner'
import ErrorBoundary from './components/ErrorBoundary'
import './index.css'
import App from './App.jsx'
import { registerSW } from 'virtual:pwa-register'

// Register PWA Service Worker
if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  registerSW({
    onNeedRefresh() {
      if (window.confirm('New version of MSMECenter is available! Reload to update?')) {
        window.location.reload();
      }
    },
    onOfflineReady() {
      console.log('MSMECenter is ready for offline operation.');
    },
  });
}

// Clear the chunk-reload guard once the app has had a few seconds to mount
// cleanly, so a later genuine chunk-load failure (a future deploy) can still
// trigger one auto-reload instead of being permanently suppressed.
setTimeout(() => sessionStorage.removeItem('chunk-reload-attempted'), 5000);

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <HelmetProvider>
      <ErrorBoundary>
        <App />
        <Toaster position="top-right" richColors closeButton />
      </ErrorBoundary>
    </HelmetProvider>
  </StrictMode>,
)
